import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clipRule="evenodd"
    d="M14 6.5H10C9.44771 6.5 9 6.94772 9 7.5L15 7.5C15 6.94772 14.5523 6.5 14 6.5ZM17 7.5C17 5.84315 15.6569 4.5 14 4.5H10C8.34315 4.5 7 5.84315 7 7.5L3 7.5C2.44772 7.5 2 7.94772 2 8.5V11.5C2 12.0523 2.44772 12.5 3 12.5H21C21.5523 12.5 22 12.0523 22 11.5V8.5C22 7.94772 21.5523 7.5 21 7.5H17ZM2 13.5H22V19.5C22 20.0523 21.5523 20.5 21 20.5H3C2.44772 20.5 2 20.0523 2 19.5V13.5Z"
    fillRule="evenodd"
  />,
  'Business',
)
